export const BOOKING_NUMBER_VARIABLE = '{{bookingNumber}}'
export const BOOKING_NUMBER_LINK_MAX_LENGTH = 2048

export const addDefaultBookingLinkProtocol = (value) => {
	const trimmed = String(value || '').trim()
	if (!trimmed) return ''
	return /^[a-z][a-z\d+.-]*:\/\//i.test(trimmed)
		? trimmed
		: `https://${trimmed}`
}

export const getBookingNumberLinkError = (value) => {
	const normalized = addDefaultBookingLinkProtocol(value)
	if (!normalized) return ''
	if (normalized.length > BOOKING_NUMBER_LINK_MAX_LENGTH) {
		return `Use ${BOOKING_NUMBER_LINK_MAX_LENGTH} characters or fewer.`
	}

	const variables = normalized.match(/{{[^{}]*}}/g) || []
	if (!variables.includes(BOOKING_NUMBER_VARIABLE)) {
		return `Include ${BOOKING_NUMBER_VARIABLE} where the booking number belongs.`
	}
	if (variables.some((variable) => variable !== BOOKING_NUMBER_VARIABLE)) {
		return `${BOOKING_NUMBER_VARIABLE} is the only supported variable.`
	}
	if (/[{}]/.test(normalized.split(BOOKING_NUMBER_VARIABLE).join(''))) {
		return `${BOOKING_NUMBER_VARIABLE} is the only supported variable.`
	}

	try {
		const parsedUrl = new URL(
			normalized.split(BOOKING_NUMBER_VARIABLE).join('BOOK-12345'),
		)
		if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
			return 'Use an http or https URL.'
		}
	} catch {
		return 'Enter a valid booking page URL.'
	}

	return ''
}

export const buildBookingPageUrl = (template, bookingNumber) => {
	const normalizedTemplate = addDefaultBookingLinkProtocol(template)
	const normalizedBookingNumber = String(bookingNumber ?? '').trim()
	if (
		!normalizedTemplate ||
		!normalizedBookingNumber ||
		getBookingNumberLinkError(template)
	) {
		return null
	}

	return normalizedTemplate
		.split(BOOKING_NUMBER_VARIABLE)
		.join(encodeURIComponent(normalizedBookingNumber))
}
